module.exports = __webpack_public_path__ + "img/member-maekawa.4c9bb839.png";